import { styled, Box } from '@mui/material'

export const RectangleChip = styled(Box)({
  display: 'flex',
  fontSize: '12px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  borderRadius: '4px',
  color: 'white',
  padding: '4px 8px',
  backgroundColor: 'rgba(173, 173, 173, 1)',
  minWidth: '30px',
  justifyContent: 'center'
});